module.exports = __webpack_public_path__ + "media/images/stars-2fbe52e395ab8f4b05e1887fe25cc165.svg";